<div class="contenedor">
    <input type="checkbox" id="toggle">
    <label for="toggle" class="button"></label>
    <nav class="nav">
      <a style="cursor: pointer;" (click)="limpiar()">Limpiar &nbsp;<i class="fas fa-sync-alt"></i></a>
      <a style="cursor: pointer;" (click)="xls()">Exp XLS &nbsp;<i class="far fa-file-pdf"></i></a>
      <a style="cursor: pointer;" (click)="pdf()">Exp PDF &nbsp;<i class="far fa-file-excel"></i></a>
      <a style="cursor: pointer;" (click)="global()">Exp Global &nbsp;<i class="far fa-file-pdf"></i></a>
    </nav>
  </div>